module.exports = __webpack_public_path__ + "img/investment_details.380edffe.svg";